var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCourseClassroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43.793,
    height: 41.311,
    viewBox: "0 0 43.793 41.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1660",
    "data-name": "Rectangle 1660",
    width: 43.793,
    height: 41.311,
    transform: "translate(0 0)",
    fill: "#525252"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3447",
    "data-name": "Group 3447",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1653",
    "data-name": "Rectangle 1653",
    width: 0.468,
    height: 11.696,
    transform: "translate(25.062 25.118) rotate(-85.836)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1654",
    "data-name": "Rectangle 1654",
    width: 0.468,
    height: 11.696,
    transform: "translate(25.381 20.749) rotate(-85.836)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1655",
    "data-name": "Rectangle 1655",
    width: 1.366,
    height: 1.366,
    transform: "translate(21.776 25.329) rotate(-85.846)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1656",
    "data-name": "Rectangle 1656",
    width: 1.366,
    height: 1.366,
    transform: "translate(22.077 20.956) rotate(-85.804)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1657",
    "data-name": "Rectangle 1657",
    width: 1.367,
    height: 1.366,
    transform: "translate(22.396 16.588) rotate(-85.804)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1658",
    "data-name": "Rectangle 1658",
    width: 0.468,
    height: 11.697,
    transform: "matrix(0.073, -0.997, 0.997, 0.073, 25.699, 16.379)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1659",
    "data-name": "Rectangle 1659",
    width: 0.468,
    height: 11.697,
    transform: "translate(26.019 12.01) rotate(-85.823)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3186",
    "data-name": "Group 3186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3185",
    "data-name": "Group 3185",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5927",
    "data-name": "Path 5927",
    d: "M22.242,5.9,39.065,7.13a.589.589,0,0,0,.657-.568l-.245-3.674a.651.651,0,0,0-.568-.657l-5.823-.425a1.981,1.981,0,0,0-3.9-.285l-6.078-.444a.65.65,0,0,0-.657.568l-.777,3.6a.591.591,0,0,0,.568.658",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5928",
    "data-name": "Path 5928",
    d: "M42.338,3.672l-1.93-.141.148,2.23.941.069a.04.04,0,0,1,.035.041L39.65,31.637a.037.037,0,0,1-.04.035l-11.442-.835-9.936-.726a.039.039,0,0,1-.035-.041l1.017-13.919a.912.912,0,0,0,.037-.508l.038-.53L23.2,12.255l.878.064.055-.746,4.361-3.187L28.189,8l-4.047,2.957-1.327-.1-.082,1.126-3.4,2.482L20.079,4.3a.039.039,0,0,1,.04-.035l.941.069.47-2.185L19.6,2.012a1.573,1.573,0,0,0-1.68,1.451L17.1,14.736l-3.119,2.155s-2.918-3.884-3.533-4.655a2.45,2.45,0,0,0-1.719-.707H5.542a2.446,2.446,0,0,0-1.748.737C3.31,13.415.132,22.993.132,22.993c-.222.616-.224,1.318.468,1.594a1.224,1.224,0,0,0,1.656-.612l1.044-2.9L4.332,17c0,.524-.365,8.684-.365,8.684l-.3,13.829A1.525,1.525,0,0,0,4.97,41.3c.915.082,1.369-.591,1.427-1.5l.738-11.5.738,11.5a1.436,1.436,0,0,0,1.51,1.464c.921.039,1.276-.857,1.218-1.762l-.3-13.828-.035-1.469.024-7.525,2.354,3.1a1.434,1.434,0,0,0,1.718.247l2.487-1.921L15.94,30.59a1.573,1.573,0,0,0,1.451,1.679l12,.876,10.734.784a1.573,1.573,0,0,0,1.679-1.451L43.789,5.352a1.573,1.573,0,0,0-1.451-1.68",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5929",
    "data-name": "Path 5929",
    d: "M7.135,10.942a2.894,2.894,0,0,0,2.973-2.807A2.893,2.893,0,0,0,7.135,5.329,2.893,2.893,0,0,0,4.161,8.135a2.894,2.894,0,0,0,2.974,2.807",
    fill: "#525252"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCourseClassroom);
export default __webpack_public_path__ + "static/media/icon_course_classroom.160b947587d12a24d2348661c79c124f.svg";
export { ForwardRef as ReactComponent };